<template>
 <!-- 其他险种出险 -->
  <div>
    <div v-show="Qtxzcx">
      <div style="font-size:20px;float:left;margin:-40px 0 0 40px;font-weight:600">其他险种出险</div>
    <!-- 主体 -->
    <div style="height:750px;background-color:white;margin:75px 40px 0 40px">
      <!-- 查询框 -->
      <div style="margin-left:2%">
        <div style="height:40px"></div>

        <div style="display:inline-block">
			<span>组织架构</span>
			<el-cascader v-model="condition.organize_ids" clearable
				style="margin-left:10px;width:300px" collapse-tags :props="props"></el-cascader>
        </div>

        <div style="display:inline-block;margin-left:10px">
          <span>唯一识别码 </span>
        <el-input v-model="condition.unique_id" style="margin-left:10px;width:160px" placeholder="请输入唯一识别码"></el-input>
        </div>

        <div style="display:inline-block;margin-left:10px">
          <span>名称/品牌 </span>
        <el-input v-model="condition.brand" style="margin-left:10px;width:160px" placeholder="请输入名称/品牌"></el-input>
        </div>

        <div style="display:inline-block;margin-left:10px">
          <span>保单号 </span>
        <el-input v-model="condition.policyNo" style="margin-left:10px;width:160px" placeholder="请输入保单号"></el-input>
        </div>

        <div style="display:inline-block;margin-left:10px">
            <span>出险时间 </span>
          <el-date-picker v-model="condition.danger_time" type="date" style="margin-left:10px;width:160px" placeholder="请选择"></el-date-picker>
        </div>

        <div style="display:inline-block;margin-left:10px">
          <span>审批状态 </span>
          <el-select v-model="condition.approval_status" style="margin-left:10px;width:160px"
                placeholder="请选择" clearable>
                <el-option v-for="item in spztList" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
            </el-select>
        </div>

        <div style="display:inline-block;margin-top:20px">
          <span>出险状态 </span>
          <el-select v-model="condition.state" style="margin-left:10px;width:160px"
                placeholder="请选择" clearable>
                <el-option v-for="item in cxztList" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
            </el-select>
        </div>


        <!-- 按钮 -->
        <div style="display:inline-block;margin-top:20px;margin-left:50px">
          <el-button type="goon" @click="Find">查询</el-button>
          <el-button type="goon" >导入</el-button>
          <el-button type="goon" >导出</el-button>
          <el-button type="goon" @click="Del()">删除</el-button>
          <el-button type="addbtn" @click="add()">新增</el-button>
        </div>
      </div>

      <!-- 表格 -->
      <div style="margin:1% 3% 0 3%">
        <el-table
          :header-cell-style="{background:'#F0F0F0',color:'#000000'}"
          :row-class-name="tableRowClassName"
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%;height:540px"
          @selection-change="handleSelectionChange">
          <el-table-column
            type="selection"
            width="55">
          </el-table-column>
          <el-table-column align="center" label="序号" width="50">
            <template slot-scope="scope_1">{{scope_1.$index + 1}}</template>
          </el-table-column>
          <el-table-column prop="organize_name" align="center" label="所属项目"></el-table-column>
          <el-table-column prop="unique_id" align="center" label="唯一识别码"></el-table-column>
          <el-table-column prop="brand" align="center"  label="名称/品牌"></el-table-column>
          <el-table-column prop="model" align="center" label="规格/型号"></el-table-column>
          <el-table-column prop="danger_time" align="center" label="出险时间"></el-table-column>
          <el-table-column prop="report_no" align="center" label="报案号"></el-table-column>
          <el-table-column prop="policyNo" align="center" label="保单号"></el-table-column>
          <el-table-column prop="settlement_status" align="center" label="理赔情况">
            <template slot-scope="scope">
                <p v-show="scope.row.settlement_status == '0'">未理赔</p>
                <p v-show="scope.row.settlement_status == '1'">已理赔</p>
                <p v-show="scope.row.settlement_status == ''">已撤案</p>
            </template>
          </el-table-column>
          <el-table-column prop="close_date" align="center" label="结案日期"></el-table-column>
          <el-table-column prop="approval_status" align="center" label="状态"  width=100>
            <template slot-scope="scope">
                <img src="../../../assets/待审批.png" v-show="scope.row.approval_status === '0'" />
                <img src="../../../assets/已同意.png" v-show="scope.row.approval_status === '1'" />
            </template>
          </el-table-column>
          <el-table-column prop="state" align="center" label="出险状态" width=100>
            <template slot-scope="scope">
                <img src="../../../assets/未出险.png" v-show="scope.row.state === '0'" />
                <img src="../../../assets/已出险.png" v-show="scope.row.state === '1'" />
            </template>
          </el-table-column>
          <el-table-column align="center" label="操作" width="150">
            <template slot-scope="scope">
              <img src="../../../assets/详情.png" @click="xiangqing(scope.row)">
              <img src="../../../assets/编辑.png" @click="bianji(scope.row)">
              <img src="../../../assets/删除.png" @click="Del(scope.row.id)">
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <el-row style="margin-top: 10px; text-align: center;">
          <el-pagination background @current-change="handleCurrentChange" :page-size="page_size"
            layout=" prev, pager, next, jumper" :total="total">
          </el-pagination>
        </el-row>
      </div>
      
    </div>
    </div>
    <add ref="adds" v-show="showadd"></add>
    <edit ref="edits" v-show="showedit"></edit>
  </div>
</template>

<script>
import axios from 'axios';
import add from './Qtxzcx_add.vue';
import edit from './Qtxzcx_edit.vue';
export default {
  components: {
    add:add,
    edit:edit,
  },
  data() {
		var organizeFind = async (e, spare8) => {
			var organizeList = await this.$globals.AxiosPost("organize/findHierarchy", {
				identification: "1",
				organize_id: e,
				spare8: spare8,
			});
			return organizeList.data;
		};
    return {
      page_num: 1,
      page_size: 10,
      total: 0,
      //删除ids
      ids: [],
      tableData:[],
      xmList:[],
      //审批状态下拉
      spztList: [{
          value: '0',
          label: '待审批'
      }, {
          value: '1',
          label: '已同意'
      }, {
          value: '2',
          label: '已驳回'
      }],
      // 出险状态下拉
      cxztList:[{
          value: '0',
          label: '未出险'
      }, {
          value: '1',
          label: '已出险'
      }],
      ruleForm:{
        project_name:'',
        unique_id:'',
        insurance_id:'',
        detailed_id:'',
        brand:'',
        model:'',
        danger_time:'',
        report_no:'',
        policy_no:'',
        policyNo:'',
        settlement_status:'',
        settlement_amount:'',
        indemnity_amount:'',
        remarks:'',
        close_date:'',
        danger_after:'',
        state:'',
        approval_status:'',
        bill_url:[],
        insurance_id:'',
        policyNo:'',
        accident_photo:[],
      },
      condition:{
        organize_ids:[],
        unique_id:'',
        brand:'',
        danger_time:'',
        policyNo:'',
        state:'',
        approval_status:'',
      },
      // 权限
      Qtxzcx:true,
      showadd:false,
      showedit:false,
	  
	  //组织架构数据
	  organizeList: [],
	  
	  //级联下拉配置
	  props: {
			lazy: true,
			async lazyLoad(node, resolve) {
				if (node.level === 0) {
					return resolve(await organizeFind('', 'group'));
				} else {
					resolve(await organizeFind(node.data.id, ''));
				}
			},
	      value: "id",
	      label: "organize_name",
	      children: "organizeList",
	      checkStrictly: true,
	      multiple: true,
	  },
      
    }
  },
  methods: {
    // 全选
    handleSelectionChange(e) {
      this.ids = [];
      e.forEach(item => {
          this.ids.push(item.id);
      });
    },
    // 返回
    Return(){
        this.showadd = false;
        this.showedit = false;
        this.Qtxzcx = true;
        this.trash();
        this.Find();
    },
    //查询
    async Find() {
		var temporary = [];
		this.condition.organize_ids.forEach(item => {
		    temporary.push(item[item.length - 1]);
		})
		var organize_ids = "";
		temporary.forEach(item => {
		    organize_ids += item + ",";
		})
		
        var url = '/InsuranceDanger/selectAll';
        var record = {
			organize_ids: organize_ids,
            page_num: this.page_num,
            page_size: this.page_size,
            id: this.condition.id,
            unique_id: this.condition.unique_id,
            brand: this.condition.brand,
            danger_time: this.condition.danger_time,
            policyNo: this.condition.policyNo,
            state: this.condition.state,
            approval_status: this.condition.approval_status,
        };
        var data = await this.$globals.AxiosPost(url, record);
        if (data === '-2000') {
            this.$message.error('服务器未响应！请稍后重试');
        } else {
            var code = data.code;
            var data = data.data;
            if (code === '200') {
                this.tableData = data.list;
                this.total = data.total;
            } else {
                this.$message.warning('请求失败！请稍后重试');
            }
        }
    },
    // 新增
    add(){
      this.Qtxzcx = false;
      this.showadd = true;
      this.$refs.adds.add;
      this.Find();
      this.trash();
    },
    // 操作修改
    bianji(e){
      this.Qtxzcx = false;
      this.showadd = true;
      this.ruleForm.id = e.id;
      this.ruleForm.insurance_id = e.insurance_id;
	  this.$refs["adds"].sbm(this.ruleForm.insurance_id);
      this.ruleForm.detailed_id = e.detailed_id;
	  
	  this.ruleForm.brand = e.brand;
	  this.ruleForm.model = e.model;
	  
      this.ruleForm.danger_time = e.danger_time;
      this.ruleForm.danger_after = e.danger_after;
	  this.ruleForm.accident_photo = [];
	  e.accident_photo.split(';').forEach(item => {
		  if(item != null && item != ''){
			  this.ruleForm.accident_photo.push({
				  url: item
			  })
		  }
	  })
      this.ruleForm.report_no = e.report_no;
      this.ruleForm.policyNo = e.policyNo;
      this.ruleForm.policy_no = e.mopolicy_nodel;
      this.ruleForm.policyNo = e.policyNo;
      this.ruleForm.settlement_status = e.settlement_status;
	  
	  if(e.bill_url != null && e.bill_url != ''){
		  this.ruleForm.bill_url.push({
			  url: e.bill_url
		  })
	  }
	  
      this.ruleForm.settlement_amount = e.settlement_amount;
      this.ruleForm.indemnity_amount = e.indemnity_amount;
      this.ruleForm.close_date = e.close_date;
      this.ruleForm.remarks = e.remarks;
    },
    // 操作详情
    xiangqing(e){
      this.Qtxzcx = false;
      this.showedit = true;
      this.$refs.edits.edit;
      this.ruleForm.id = e.id;
      this.ruleForm.insurance_id = e.insurance_id;
      this.ruleForm.detailed_id = e.detailed_id;
      this.ruleForm.unique_id = e.unique_id;
      this.ruleForm.insurance_name = e.insurance_name;
      this.ruleForm.policy_no = e.policy_no;
      this.ruleForm.brand = e.brand;
      this.ruleForm.model = e.model;
      this.ruleForm.danger_time = e.danger_time;
      this.ruleForm.danger_after = e.danger_after;
      this.ruleForm.report_no = e.report_no;
      this.ruleForm.policy_no = e.policy_no;
      this.ruleForm.settlement_amount = e.settlement_amount;
      this.ruleForm.indemnity_amount = e.indemnity_amount;
      this.ruleForm.close_date = e.close_date;
      this.ruleForm.remarks = e.remarks;
      this.ruleForm.bill_url = e.bill_url;
	  
	  this.ruleForm.accident_photo = [];
	  e.accident_photo.split(';').forEach(item => {
	  		  if(item != null && item != ''){
	  			  this.ruleForm.accident_photo.push(item)
	  		  }
	  })
      this.ruleForm.settlement_status = e.settlement_status;
    },
    //删除
    Del(e) {
      var ids;
      if (e === null || e === '' || e === undefined) {
        if (this.ids === null || this.ids.length <= 0) {
          this.$message.warning('请先选择操作数据！');
          return false;
        }
        ids = this.ids;
      } else {
        ids = [e];
      }
      const url = this.$globals.http + '/InsuranceDanger/del';
      axios
        .post(url, {
          ids: ids,
        })
        .then((response) => {
          var code = response.data.code;
          var data = response.data.data;

          if (code === '200') {
            this.$message.success(data);
            this.Find();
          } else {
            this.$message.warning('请求失败！请稍后重试');
          }
        })
        .catch((error) => {
          console.log(error);
          this.$message.error('服务器未响应！请稍后重试');
        });
    },
    //清除数据
    trash() {
      this.ruleForm.id = '';
      this.ruleForm.insurance_id = '';
      this.ruleForm.detailed_id = '';
      this.ruleForm.unique_id = '';
      this.ruleForm.insurance_name = '';
      this.ruleForm.policy_no = '';
      this.ruleForm.brand = '';
      this.ruleForm.model = '';
      this.ruleForm.danger_time = '';
      this.ruleForm.danger_after = '';
      this.ruleForm.report_no = '';
      this.ruleForm.policy_no = '';
      this.ruleForm.settlement_status = '';
      this.ruleForm.settlement_amount = '';
      this.ruleForm.indemnity_amount = '';
      this.ruleForm.close_date = '';
      this.ruleForm.remarks = '';
      this.ruleForm.bill_url = [];
      this.ruleForm.accident_photo = [];
    },
	//初始化组织架构及下面的人
	async organizeFind() {
	    var organizeList = await this.$globals.AxiosPost("organize/selectOrganizeStaff", {
	        identification: "1",
	    });
	    this.organizeList = this.getTreeData(organizeList.data);
	
	},
	getTreeData(data) {
	    // 循环遍历json数据
	    for (var i = 0; i < data.length; i++) {
	
	        if (data[i].organizeList.length < 1) {
	            // children若为空数组，则将children设为undefined
	            data[i].organizeList = undefined;
	        } else {
	            // children若不为空数组，则继续 递归调用 本方法
	            this.getTreeData(data[i].organizeList);
	        }
	    }
	    return data;
	}
  },
	created() {
    this.Find();
    this.organizeFind();

  },
}
</script>

<style>
.el-button--goon:focus,
.el-button--goon:hover {
  background: #006E4B;
  border-color:  #05573d;
  color: #fff;
}
.el-button--addbtn:focus,
.el-button--addbtn:hover {
  background: #fff;
  border-color:  #05573d;
  color:  #006E4B;
}
.el-button--goon {
  color: #FFF;
  background-color: #006E4B;
  border-color:  #006E4B;
  font-size: 15px;
  width: 85px;
}
.el-button--addbtn {
  color:  #006E4B;
  background-color: #fff;
  border-color:  #006E4B;
  font-size: 15px;
  width: 85px;
}
.el-table .warning-row {
  background: oldlace;
}
.el-table .success-row {
  background: #f0f9eb;
}
.el-checkbox__input.is-checked .el-checkbox__inner {
  background-color:  #006E4B;
  border-color:  #006E4B;
}
.el-checkbox__input.is-focus .el-checkbox__inner {
  border-color:  #006E4B;
}
.el-checkbox__inner:hover{
  border-color:  #006E4B;
}

</style>


// WEBPACK FOOTER //
// Qtxzcx.vue?92d2716c